/*
 * @Author: Chao Yang
 * @Date: 2020-09-04 10:19:59
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-09-04 16:47:55
 */
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { getMonth, lastDayOfMonth } from 'date-fns';

@Component({
  selector: 'month-picker',
  templateUrl: './month-picker.component.html',
})
export class MonthPickerComponent implements OnInit {
  monthList: any[] = [
    { text: 'Jan', value: 1 },
    { text: 'Feb', value: 2 },
    { text: 'Mar', value: 3 },
    { text: 'Apr', value: 4 },
    { text: 'May', value: 5 },
    { text: 'Jun', value: 6 },
    { text: 'Jul', value: 7 },
    { text: 'Aug', value: 8 },
    { text: 'Sep', value: 9 },
    { text: 'Oct', value: 10 },
    { text: 'Nov', value: 11 },
    { text: 'Dec', value: 12 },
  ];
  @Output()
  onSelect = new EventEmitter<number>();
  @Input() currentDate: Date = new Date();
  @Input() year: number;
  @Input() minDate: Date;
  @Input() maxDate: Date;

  currentMonth: number = 1;

  constructor() { }

  ngOnInit() {
    this.currentMonth = getMonth(this.currentDate) + 1;
  }

  monthClick(month: number) {
    this.onSelect.emit(month);
  }

  isValidMonth(month: number) {
    if (this.year) {
      if (
        this.minDate &&
        lastDayOfMonth(new Date(this.year, month - 1, 1)) < this.minDate
      ) {
        return false;
      }
      if (this.maxDate && new Date(this.year, month - 1, 1) > this.maxDate) {
        return false;
      }
    }
    return true;
  }
}
